module.exports = __webpack_public_path__ + "img/videoai.1bfdb387.png";